<template>
    <div
        class="rounded-lg border p-4"
        :class="
            paymentRequest.payable
                ? 'border-orange-200 bg-orange-50/60 dark:border-orange-500/30 dark:bg-orange-500/10'
                : 'border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800'
        "
    >
        <div class="flex items-start justify-between gap-4">
            <div>
                <p class="text-sm font-medium text-slate-800 dark:text-slate-100">
                    {{ paymentRequest.description || paymentRequest.type_label }}
                </p>
                <p class="text-lg font-semibold text-slate-900 dark:text-white mt-0.5">
                    ${{ formattedAmount }}
                </p>
                <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
                    <template v-if="paymentRequest.status === 'paid'">
                        Paid {{ paidDate }}
                    </template>
                    <template v-else-if="paymentRequest.status === 'cancelled'">
                        Cancelled
                    </template>
                    <template v-else>Awaiting your payment</template>
                </p>
            </div>

            <div class="shrink-0">
                <span
                    v-if="paymentRequest.status === 'paid'"
                    class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200 dark:bg-green-500/20 dark:text-green-400 dark:border-green-500/30"
                >
                    <Icon icon="check" :width="12" :height="12" />
                    Paid
                </span>
                <span
                    v-else-if="paymentRequest.status === 'cancelled'"
                    class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-600 border border-slate-200 dark:bg-slate-700 dark:text-slate-300 dark:border-slate-600"
                >
                    Cancelled
                </span>
                <ActionButton
                    v-else-if="canPay"
                    label="Pay now"
                    :loading="paying"
                    :button-id="`pay-${paymentRequest.id}`"
                    classes="inline-flex items-center px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-medium rounded-lg transition-colors"
                    @clicked="$emit('pay', paymentRequest)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import ActionButton from '@/components/action-button.vue';

const props = defineProps({
    paymentRequest: { type: Object, required: true },
    paying: { type: Boolean, default: false },
    canPay: { type: Boolean, default: true },
});

defineEmits(['pay']);

const formattedAmount = computed(() =>
    Number(props.paymentRequest.amount).toFixed(2)
);

const paidDate = computed(() => {
    if (!props.paymentRequest.paid_at) {
        return '';
    }
    return new Date(props.paymentRequest.paid_at).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
});
</script>
